import React, { useState, useEffect, useRef } from "react";
import { AppBar, Toolbar, Typography, IconButton, Drawer, Box, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { usePageTransition } from "../../context/PageTransitionContext.tsx";

import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//import { useTranslation } from "react-i18next";


gsap.registerPlugin(ScrollToPlugin);

const Navbar: React.FC = () => {
  //const { i18n, t } = useTranslation(); // Multilingua
  const [showOverlay, setShowOverlay] = useState(false); // Effetti overlay del refresh pagina
  const { navigateWithTransition } = usePageTransition();
  const location = useLocation();

  // useEffect(() => {
  //   if (sessionStorage.getItem("languageChanging") === "true") { // Controlla se la pagina è stata appena ricaricata con il cambio lingua
  //     setShowOverlay(true); // Mostra l'overlay subito
  //     setTimeout(() => {
  //       setShowOverlay(false); // Nasconde l'overlay dopo l'animazione
  //       sessionStorage.removeItem("languageChanging"); // Pulisce lo stato
  //     }, 1500); // Tempo dell'animazione
  //   }
  // }, []);

  // Cambio lingua
  //const changeLanguage = () => {
  //  setShowOverlay(true); // Attiva l'effetto overlay
  //  setTimeout(() => {
  //    sessionStorage.setItem("languageChanging", "true"); // Salva lo stato dell'animazione
  //    const newLang = i18n.language === "en" ? "it" : "en"; // Cambia la lingua DOPO che l'overlay ha coperto tutto
  //    i18n.changeLanguage(newLang).then(() => {
  //      window.location.reload();
  //    });
  //  }, 700); // Aspetta prima di cambiare la lingua
  //};

  const [drawerOpen, setDrawerOpen] = useState(false); // Stati

  // Chiudi il menu burger dopo il click su un link
  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  // Gestione navigazione con transizione
  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    if (location.pathname !== path) {
      navigateWithTransition(path);
    }
    closeDrawer();
  };

  useEffect(() => {
    // Intercetta tutti i link della navbar per applicare GSAP
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault(); // Previene il comportamento predefinito dello scroll
        const targetId = link.getAttribute("href")?.substring(1);
        if (targetId) {
          gsap.to(window, {
            duration: 1.2,
            scrollTo: `#${targetId}`,
            ease: "power2.out",
          });
        }
        closeDrawer(); // Chiude il menu burger
      });
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", () => {});
      });
    };
  }, []);
  const headerRef = useRef<HTMLElement | null>(null);

  return (
    <>
      {/* Overlay di transizione */}
      {showOverlay && <div className="page-transition-overlay"></div>}

      <AppBar position="fixed" className="navbar header-fixed" ref={headerRef}>
        <Toolbar className="navbar__toolbar">
          <Typography
            variant="h6"
            className="navbar__logo"
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            <NavLink to="/" onClick={(e) => handleNavigation(e, '/')}>
              <img src="/loghi/sito/logo.png" alt="Camilla Cino Design Dev" className="navbar__logo-img" />
            </NavLink>
          </Typography>
          <Typography
            variant="h6"
            className="navbar__logo"
            sx={{ display: { xs: "flex", md: "none" } }}
          >
            <NavLink to="/" onClick={(e) => handleNavigation(e, '/')}>
              <img src="/loghi/sito/logo.png" alt="Camilla Cino Design Dev" className="navbar__logo-img navbar__logo-img--mobile" />
            </NavLink>
          </Typography>

          {/* Link a destra */}
          <Box className="navbar__links" sx={{ display: { xs: "none", md: "flex" }, alignItems: {xs: "none", md: "center"} }}>
            {/* <Button onClick={changeLanguage}>
              {i18n.language === "en" ? "🇮🇹 Italiano" : "🇬🇧 English"}
            </Button> */}

            <NavLink to="/chisono" onClick={(e) => handleNavigation(e, '/chisono')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Chi sono">Chi sono</NavLink>
            <NavLink to="/servizi" onClick={(e) => handleNavigation(e, '/servizi')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Servizi">Servizi</NavLink>
            <NavLink to="/lavori" onClick={(e) => handleNavigation(e, '/lavori')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Lavori">Lavori</NavLink>
            <NavLink to="/partners" onClick={(e) => handleNavigation(e, '/partners')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Partners">Partners</NavLink>
            <NavLink to="/prezzi" onClick={(e) => handleNavigation(e, '/prezzi')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Prezzi">Prezzi</NavLink>
            <NavLink to="/blog" onClick={(e) => handleNavigation(e, '/blog')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Blog">Blog</NavLink>
            {/* <NavLink to="/cms" onClick={(e) => handleNavigation(e, '/cms')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina CMS">CMS</NavLink> */}
            <NavLink to="/contatti" onClick={(e) => handleNavigation(e, '/contatti')} className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`} aria-label="Vai alla pagina Contatti">Contatti</NavLink>
          </Box>

          {/* Menù burger per mobile */}
          <IconButton color="inherit" edge="start" onClick={() => setDrawerOpen(true)} sx={{ display: { xs: "flex", md: "none" } }}>
            <MenuIcon />
          </IconButton>
        </Toolbar>

        {/* Drawer (menu burger) */}
        <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer} className="drawer_laterale">
          <Box sx={{ width: 280 }} role="presentation" className="burger-menu">
            <IconButton
              onClick={closeDrawer}
              className="burger-menu__close"
              aria-label="Chiudi menu"
            >
              <CloseIcon />
            </IconButton>
            <NavLink to="/chisono" onClick={(e) => handleNavigation(e, '/chisono')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Chi sono">Chi sono</NavLink>
            <NavLink to="/servizi" onClick={(e) => handleNavigation(e, '/servizi')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Servizi">Servizi</NavLink>
            <NavLink to="/lavori" onClick={(e) => handleNavigation(e, '/lavori')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Lavori">Lavori</NavLink>
            <NavLink to="/partners" onClick={(e) => handleNavigation(e, '/partners')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Partners">Partners</NavLink>
            <NavLink to="/prezzi" onClick={(e) => handleNavigation(e, '/prezzi')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Prezzi">Prezzi</NavLink>
            <NavLink to="/blog" onClick={(e) => handleNavigation(e, '/blog')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Blog">Blog</NavLink>
            {/* <NavLink to="/cms" onClick={(e) => handleNavigation(e, '/cms')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina CMS">CMS</NavLink> */}
            <NavLink to="/contatti" onClick={(e) => handleNavigation(e, '/contatti')} className={({ isActive }) => isActive ? 'active' : ''} aria-label="Vai alla pagina Contatti">Contatti</NavLink>
          </Box>
        </Drawer>
      </AppBar>
      {/* <MainContent headerRef={headerRef} /> */}
    </>
  );
};

export default Navbar;